var map = {
	"./aed.png": 582,
	"./aud.png": 583,
	"./bgn.png": 584,
	"./bhd.png": 585,
	"./cad.png": 586,
	"./chf.png": 587,
	"./cny.png": 588,
	"./czk.png": 589,
	"./dkk.png": 590,
	"./eur.png": 591,
	"./gbp.png": 592,
	"./hkd.png": 593,
	"./hrk.png": 594,
	"./huf.png": 595,
	"./idr.png": 596,
	"./ils.png": 597,
	"./inr.png": 598,
	"./jpy.png": 599,
	"./kes.png": 600,
	"./kwd.png": 601,
	"./mxn.png": 602,
	"./myr.png": 603,
	"./nok.png": 604,
	"./nzd.png": 605,
	"./omr.png": 606,
	"./php.png": 607,
	"./pln.png": 608,
	"./qar.png": 609,
	"./ron.png": 610,
	"./rub.png": 611,
	"./sar.png": 612,
	"./sek.png": 613,
	"./sgd.png": 614,
	"./thb.png": 615,
	"./try.png": 616,
	"./ugx.png": 617,
	"./usd.png": 618,
	"./zar.png": 619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 581;